<app-table-generator
    [tableInput]="tableGenInput"
    [widgetRef]="widgetRef"
></app-table-generator>
